import * as urls from "./url";
import client, { getHeader } from "../client";
import { updateNewRelicStats, interceptor } from "../../util/util";

//user-service

export const getJWTTokenCall = () => {
  updateNewRelicStats();
  return client.get(urls.getJWTToken, getHeader());
};
export const getRefreshTokenCall = (header,postData) => client.post(urls.getRefreshToken, postData, header);
export const logoutCall = () => {
  updateNewRelicStats();
  return client.post(urls.logOut, "", getHeader());
};

export const getPermissionsCall = async () => interceptor(async () => client.post(urls.getPermissions, "", getHeader()));
